<script>
    let className = '';
    export { className as class };
</script>

<svg width="100%" height="100%" viewBox="0 0 120 119" fill="none" xmlns="http://www.w3.org/2000/svg" class={className}>
    <g style="mix-blend-mode:soft-light">
        <mask
            id="mask0_13413_83596"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="120"
            height="119"
        >
            <rect x="0.0651855" y="0.0234375" width="118.959" height="118.959" rx="15.0581" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_13413_83596)">
            <g opacity="0.2">
                <path
                    d="M125.8 -76.7445L-6.71118 55.4876L-6.71118 92.5059L125.8 -39.7262L125.8 -76.7445Z"
                    fill="white"
                />
                <path d="M125.8 54.9892L-6.71118 187.221L-6.71118 224.406L125.8 92.0075L125.8 54.9892Z" fill="white" />
                <path
                    d="M125.468 -142.275L-6.71118 -10.3767L-6.71118 26.6416L125.8 -105.59L125.8 -142.275L125.468 -142.275Z"
                    fill="white"
                />
                <path d="M125.8 -10.8783L-6.71118 121.354L-6.71118 158.372L125.8 26.14L125.8 -10.8783Z" fill="white" />
            </g>
        </g>
    </g>
</svg>
